import { useNavigation, useRoute } from '@react-navigation/core'
import { StackActions } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { TransactionQueryComp } from '../../comps/TransactionQueryComp'
import { useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'

export const MiniStatementScreen = () => {
  const { getMiniStatementApi, getBankId, fetchTnxListStatus, vid, getConsentDetails } = useStores((root) => ({
    getMiniStatementApi: root.customer.getMiniStatementApi,
    getBankId: root.banks.getBankId,
    vid: root.customer.vid,
    fetchTnxListStatus: root.customer.fetchTnxListStatus,
    getConsentDetails: root.consents.getConsentDetails,
  }))
  const navigation = useNavigation()
  const routes = useRoute()
  const [lazyGetStatement, getStatementHandler] = useLazyApiData(getMiniStatementApi)
  const consentDetails = getConsentDetails('CUSTOMER_MS')
  const [routeData, setRouteData] = useState({})

  useEffect(() => {
    navigation.setOptions({ headerTitle: 'Mini Statement' })
  }, [navigation])

  useEffect(() => {
    if (getStatementHandler.state === 'fulfilled') {
      // navigation.navigate(Screens.STATEMENT_LIST as never)
      console.log('getStatementHandler', getStatementHandler)
      if (fetchTnxListStatus === 'SUCCESS') {
        navigation.dispatch(StackActions.replace(Screens.STATEMENT_LIST))
      } else {
        const showRetry = getStatementHandler?.data?.responseCode !== 'WL'
        navigation.dispatch(
          StackActions.replace(Screens.CASH_WITHDRAWAL_STATUS, {
            ...routeData,
            type: 'mini_statement',
            vid,
            showRetry,
          }),
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchTnxListStatus, getStatementHandler, navigation, vid])

  const fetchTransactionList = ({ bankName, aadhaarNo, mobileNo, fingerprintData, vid, authMode }: any) => {
    setRouteData({
      aadhaarNo,
      bankId: getBankId(bankName, 'CUSTOMER_MS'),
      bankName,
      mobileNo,
      vid,
      consentDetails,
      authMode,
      activityType: 'CUSTOMER_MS',
    })
    lazyGetStatement(
      aadhaarNo,
      getBankId(bankName, 'CUSTOMER_MS'),
      bankName,
      mobileNo,
      fingerprintData,
      vid,
      consentDetails,
      authMode,
    )
  }

  return (
    <TransactionQueryComp
      params={{ ...(routes?.params ?? {}) }}
      onSubmit={fetchTransactionList}
      isLoading={getStatementHandler.state === 'pending'}
      shouldShowLinkAadhaarDialog={
        getStatementHandler.state === 'rejected' && getStatementHandler?.data?.data?.responseCode === '22413'
      }
      activityType="CUSTOMER_MS"
    />
  )
}
